module.exports = __webpack_public_path__ + "static/media/wiser_by_feller.73f04b40.png";